exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._2hbepvp4xhvva37f47dvvckfc4k12skk1q4rq6wdpkgqc9rykc9avvp2f4bymmxvqqkmwfuh5t9fv58jhsend2cq58u6z3bxjeggh1p-Multilingual-module-multilingual-select{position:relative}", "", {"version":3,"sources":["C:/a/_work/5/s/src/components/Multilingual/C:/a/_work/5/s/src/components/Multilingual/Multilingual.module.scss"],"names":[],"mappings":"AAIA,kJACI,iBAAkB,CACrB","file":"Multilingual.module.scss","sourcesContent":["@import '../../common-scss/breakpoints.scss';\r\n\r\n@import '../../common-scss/variables.scss';\r\n\r\n.multilingual-select {\r\n    position: relative;\r\n}\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"multilingual-select": "_2hbepvp4xhvva37f47dvvckfc4k12skk1q4rq6wdpkgqc9rykc9avvp2f4bymmxvqqkmwfuh5t9fv58jhsend2cq58u6z3bxjeggh1p-Multilingual-module-multilingual-select"
};